export default defineNuxtRouteMiddleware((to) => {
  // skip middleware on server
  if (import.meta.server) return

  if (to.params.route === 'registrieren-airbus' && !to.query.actioncode) {
    const newTo = { ...to }
    newTo.query.actioncode = 'airbus'
    return newTo
  }

  return
})
